import {DefaultFormConfig, setFormConfig} from 'sos-eservice-common/js/config';
import {ResourceItem, StepFieldsMap} from 'sos-common/js/commonTypes';
export class QualityRegConfig extends DefaultFormConfig {

    constructor(translations: ResourceItem[], public basePath: string, public stepFieldsMap: StepFieldsMap) {
        super(translations, basePath, stepFieldsMap);
    }
}
